/**
 * Play a 1-up sound effect using Web Audio API
 * Mario-style ascending notes
 */
export const playOneUpSound = () => {
  try {
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    const now = audioContext.currentTime;

    // Create a series of ascending notes (E, G, E, C, D, G)
    const notes = [
      { freq: 659.25, start: 0, duration: 0.1 },      // E5
      { freq: 783.99, start: 0.1, duration: 0.1 },    // G5
      { freq: 1046.50, start: 0.2, duration: 0.1 },   // C6
      { freq: 1318.51, start: 0.3, duration: 0.1 },   // E6
      { freq: 1567.98, start: 0.4, duration: 0.1 },   // G6
      { freq: 2093.00, start: 0.5, duration: 0.3 }    // C7 (held)
    ];

    notes.forEach(note => {
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.frequency.value = note.freq;
      oscillator.type = 'square'; // Classic 8-bit sound

      // Envelope for more natural sound
      gainNode.gain.setValueAtTime(0, now + note.start);
      gainNode.gain.linearRampToValueAtTime(0.3, now + note.start + 0.01);
      gainNode.gain.linearRampToValueAtTime(0, now + note.start + note.duration);

      oscillator.start(now + note.start);
      oscillator.stop(now + note.start + note.duration);
    });
  } catch (error) {
    console.log('Audio playback not supported');
  }
};
